<template>
    <fe-dialog v-if="value"
        title="Update Subscribers"
        @close="$emit('input',false)"
        :width="400"
        :footer="false"
    >
        <div class="mb-5">
            Subscribers may receive email notifications when a form is created or edited using this template. If the template includes student-specific fields, subscribers who have access to those students will receive email notifications.
            <span style="color:#006C90; cursor:pointer;" @click="openLearnMore">Learn more <v-icon color="#006C90">far fa-external-link-alt</v-icon></span>
        </div>
        <fe-grid
            ref="grid"
            simpleInsert="id"
            simpleInsertPlaceholderText="Add subscriber"
            displayDensity="medium"
            :rowData="rowData"
            :showToolbar="false"
            :columnDefs="columnDefs"
            domLayout="autoHeight"
            @simpleInsert="create"
            :simpleInsertConfig="{
                type:'combo',
                url:'users.php?action=get&active=1',
                itemText:'user_full_name',
                filter: function(x) {
                    if(!this.index) {
                        let index = {}
                        this.forEach(y => index[y.user_id]=true)
                        Object.defineProperty(this,'index',{value:index})
                    }
                    return !this.index[x.id]
                }
            }"
            class="smartforms-subscribers-user-grid"
        />
        
        <fe-crud
            ref="crud"
            :defaultParams="{form_id:templateId}"
            :config="$models.formSubscriber"
            @read="rowData = $event"
            autoload
        />
    
    </fe-dialog>
</template>

<script>

const emptyHeader = {
    template: '<div></div>'
}

export default {
    name: 'Subscribers',

    components: {
        emptyHeader,
    },

    props: ['value', 'templateId'],

    data() {
        let me = this
        return {
            rowData: [],
            columnDefs: [
                { 
                    headerName:'Subscriber', 
                    field:'user_full_name', 
                    width: 400,
                    cellStyle() {
                        return {
                            'border': 'none'
                        }
                    }, 
                },
                {
                    headerName: 'Delete',
                    field: 'delete_option',
                    maxWidth: 60,
                    cellRenderer(v) {
                        return '<i class="fe-grid-icon fal fa-trash theme--light"></i>'
                    },
                    cellStyle() {
                        return {
                            'cursor': 'pointer',
                            'border': 'none',
                            'text-align': 'right'
                        }
                    },
                    onCellClicked: function (v) {
                        me.$confirmDelete(v.data, () => {
                            me.$refs.crud.destroy(v.data).finally(() => me.$refs.crud.read() )
                        })
                    },
                    headerComponentFramework: 'emptyHeader'
                }
            ],
        }
    },
    
    methods: {
        create(e) {
            this.$refs.crud.create([{
                user_id: e.id,
                form_id: this.templateId,
            }]).finally(() => this.$refs.crud.read())
        },
        openLearnMore() {
            window.open('https://educlimber.illuminateed.com/hc/en-us/articles/360058623333-Creating-a-smartFORM-Template?utm_lp=forethought-chat&utm_source=forethought-chat')
        }
    },
}
</script>

<style lang="scss" scoped>
.smartforms-subscribers-user-grid {
    ::v-deep .ag-header-cell {
        border: none !important;
    }
}
</style>
